import React, { useContext } from 'react'
import { SettingsContext } from '@/context/settings-context'
import { cn } from '@/lib/utils'

const AD_RECOMMENDATIONS = [
    {
        title: 'Keep ad copy short',
        description: 'Primary text should span 1-3 lines at most.'
    },
    {
        title: 'Communicate what you want people to do',
        description: 'Communicating what you want people to do at a glance is the most important goal of your ad. All of your text should be developed with this goal in mind. A range of call-to-action buttons are available, depending on your business goals.'
    },
    {
        title: 'Character limitations',
        description: 'Text in your ad may be truncated if it exceeds the character limitation. The recommended text length for most placements is 125 characters for the Primary text field, 40 characters for the Headline field and 25 characters for the Description field. However, your text may be further truncated across various placements and devices. We recommend keeping your text as short as possible to limit truncation.'
    }
]

export const Recommendations = () => {
    const { theme } = useContext(SettingsContext)
    const textColor = theme === 'dark' ? 'text-white' : 'text-dark'

    return (
        <div className="tw:mt-6">
            <h5 className="tw:mb-2 tw:!text-base tw:!font-semibold tw:text-white">Recommendations</h5>
            
            <ul className="tw:list-disc tw:!pl-5 tw:space-y-1">
                {AD_RECOMMENDATIONS.map((recommendation, index) => (
                    <li key={index} className={cn('tw:!text-sm tw:leading-relaxed', textColor)}>
                        <span className="tw:font-semibold tw:text-white">{recommendation.title}:</span> {recommendation.description}
                    </li>
                ))}
            </ul>
        </div>
    )
}